import React, { useEffect, useState } from 'react'
import KFCUncle from '../../Assetes/Images/login-animation.gif';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import OtpModal from '../Cart/OtpModal';
import LoginDetail from './LoginDetail';
import Api from '../../Components/Api';
import { signup, sendOtp, changePasswordOtp, customerSignIn, loginCustomerWithSocial, sendOtpForFP, verifyOtpNew, signupNew } from '../../Redux/actions/customer';
import { connect, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import FacebookLogin from 'react-facebook-login';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import Header from '../../Components/Header';
import useTrackEvent from '../../hooks/useTrackHook';
import GoBack from '../BackButton/GoBack';
import { v4 as uuid } from 'uuid';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { checkPhone, MOBILE_STARS, NUMBERS_LIMIT, PHONE_CODE } from '../../lib';
import Footer from '../../Components/Footer';

const FACEBOOK_APP_ID:any=process.env.REACT_APP_FACEBOOK_APP_ID


function LoginPage(props: any) {
  const { signup, changePasswordOtp } = props;

  const history = useHistory();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showdetails, setShowDetaild] = useState(true)

  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [disable, setDisable] = useState(false);
  const [disablePassword, setDisablePassword] = useState(false);

  const [otp, setOtp] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [forgetPhone, setForgetPhone] = useState('')
  const [showPassword, setShowPassword] = useState(false);
  // googleLogin user
  const [user, setUser]: any = useState([]);
  const [addEvent] = useTrackEvent();
  const isLogged = useSelector((state: any) => state.customer.isLogged);

  // login
  const [matchPasswordError, setMatchPasswordError] = useState(false);
  const [verifyBtnDisable, setVerifyBtnDisable] = useState(true);
  const [isChecked2, setIsChecked2] = useState(false);
  const [disableSignupBtn, setDisableSignupBtn] = useState(true);
  const [disableGuestBtn, setDisableGuestBtn] = useState(true);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('')

  const [email, setEmail] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [gender, setGender] = useState("male")
  const [date, setDate] = useState('');
  const [firstNameError,setFirstNameError]=useState(false)
  const [lastNameError,setLastNameError]=useState(false)
  const [emailError,setEmailError]=useState(false)
  const [dobError,setDobError]=useState(false);
  const [btnDisable,setBtnDisable]=useState(true);
  const lang = useCurrentLocale();
  const { t } = useTranslation();

  useEffect(() => {
    if (isLogged) {
      history.push(`/${lang}/`);
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  
  const handlePhone = (e: any) => {
        const { value } = e.target;
        if (value.length <= NUMBERS_LIMIT) {
            setPhone(value);
        }
        if(!checkPhone(value)) return 
        if (value.length == NUMBERS_LIMIT) {
            setDisableSubmit(false);
            setBtnDisable(false);
        }
        if (value.length < NUMBERS_LIMIT) {
            setDisableSubmit(true);
            setBtnDisable(true);
        }
  };

  const handleEnterPress = (e: any) => { 
    if (e.key == "Enter" && !btnDisable && !disable ) {
      handleSendOtp()
    }
    else if (e.key == "Enter") {
      toast.error(t("PLEASE_FILL_REQUIRED_FIELDS"))
    }
  }
  

  const handleGoogleLogin = useGoogleLogin({

    onSuccess: (codeResponse: any) => setUser(codeResponse),
    onError: (error: any) => {
      // console.log('Login Failed google------:', error)
    }
  });

  useEffect(
    // https://blog.logrocket.com/guide-adding-google-login-react-app/
    () => {

      if (user) {
        axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: 'application/json'
            }
          })
          .then((res: any) => {
            let randomstring = uuid() + "_" + Date.now();
            if (res.data.verified_email) {
              const data: any = {
                first_name: res.data.given_name,
                last_name: res.data.family_name,
                login_name: res.data.name,
                email_address: res.data.email,
                profile_pic: res.data.picture,
                phone_number: randomstring,
                is_active: 1,
                is_social_login: 1
              }
              props.loginCustomerWithSocial(data, history);
            } else {
              toast.error("Your Email is not verified by google", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 });
            }
          })
          .catch((err: any) => {
            // console.log(err)
          });
      }
    },
    [user]
  );

  const responseFacebook = (response: any) => {
    let randomstring = uuid() + "_" + Date.now();
    const data: any = {
      first_name: response?.first_name,
      last_name: response?.last_name,
      login_name: response?.name,
      email_address: response?.email,
      phone_number: randomstring,
      profile_pic: response?.picture?.data?.url,
      is_active: 1,
      is_social_login: 1
    };
    //props.loginCustomerWithSocial(data, history);
    if (response.status != "unknown") props.loginCustomerWithSocial(data, history);
  }

  const handleOtpGmail = () => {
    history.push(`/${lang}/otp-gmail`);

  }

  //here
  const handleSendOtp=()=>{
    props.sendOtpNew({
      phone_number: `${PHONE_CODE}-` + phone
    }, setShow)
    setShowDetaild(true)
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'signUpClick',
      'ecommerce': {
        'phoneno': `${PHONE_CODE}-` + phone
      }
    })
  }
  const handleVerifyOtp = () => {
    let data = {
      phone_number: `${PHONE_CODE}-` + phone,
      otp: otp
    }
    // setDisableVerifyBtn
    props.verifyOtpNew(data,history,`/${lang}/menu`,setShow,setShowDetaild)

  }
  useEffect(() => {
    if (otp.length >= 4) {
      handleVerifyOtp()
      setVerifyBtnDisable(false)
    } else {
      setVerifyBtnDisable(true)
    }

  }, [otp])

  const handleSignup = () => {
    let obj: any = {
        phone_number: `${PHONE_CODE}-` + phone,
        first_name: firstname,
        last_name: lastname,
        login_name: firstname + " " + lastname,
        email_address: email,
        gender: gender,
        customer_birthday: date,
        login_password: "",
        is_active: 1
  }
  props.signupNew(obj, history);
  }
  

  return (
    <div className="login-container-area">
      <div className="login-container">
        <div className="login-bucket">
          <Header />
        </div>
        <div className="login-field position-relative about-us">
          <div className='login-goback web-backbtn'>
          <GoBack/>
          </div>
          <div className="row">
            <div className="col-lg-6 d-flex justify-content-center align-items-end">
              <img className="login-animation" src={KFCUncle} alt="" />
            </div>
            <div className="col-lg-6">
              <div className="welcome-login">
                <h3>{t("WELCOME")}</h3>

                <div className="col-lg-12">
                  <TextField
                    onKeyPress={handleEnterPress}
                    name="input1"
                    value={phone}
                    onChange={handlePhone}
                    autoComplete="mobile tel"
                    className="field-style kfc-number-field"
                    label={<div className='font-normal d-flex gap-1'><p>{t("PHONE_NUMBER")} ({MOBILE_STARS})</p><p className='color-theme h4 '>*</p></div>}
                    variant="filled"
                    color="error"
                    type="number"
                    id="outlined-number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      startAdornment: 
                        <InputAdornment
                          className="number-field"
                          position="start"
                        >
                          {PHONE_CODE}
                        </InputAdornment>,
                        inputMode: 'numeric',
                    }
                    }
                    helperText={disable ? t("PHONE_ERROR",{limit:NUMBERS_LIMIT}) : ""}
                  />
                </div>
                <div>
                  <Button
                    disabled={disable ||  disableSubmit}
                    onClick={handleSendOtp}
                    className={`${disable || disableSubmit
                        ? "disable-btn "
                        : "able-btn"
                      } m-auto d-flex mt-4 coupon-otp-btn w-100 font-medium fblogin`}
                    variant="contained"
                    color="error"
                  >
                    {t("LOGIN")}
                  </Button>

                  <Modal
                    className="payment-modal"
                    show={show}
                    onHide={handleClose}
                    centered
                  >
                    <div className="modal-design">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <Modal.Header
                      className="justify-content-center"
                      closeButton
                    >
                      
                    {showdetails ?
                        <h5 className='font-bold'>{t("ADD_OTP")}</h5>
                        :
                        <h5 className='font-bold'>{t("ADD_YOUR_DETAILS")}</h5>
                      
                      } 
                    </Modal.Header>
                    
                    <Modal.Body className='w-100 delivery-order'>
                      {showdetails ? //here
                        <OtpModal otp={otp} setOtp={setOtp} phone_number={`${PHONE_CODE}-` + phone} />
                        :
                        <div className='guest-login-password'>
                          <LoginDetail setBtnDisable={setBtnDisable} firstNameError={firstNameError} setFirstNameError={setFirstNameError} lastNameError={lastNameError} setLastNameError={setLastNameError} dobError={dobError} setDobError={setDobError} matchPasswordError={matchPasswordError} setMatchPasswordError={setMatchPasswordError} isChecked={isChecked2} setIsChecked={setIsChecked2} setDisableGuestBtn={setDisableGuestBtn} password={password} setPassword={setPassword} confirmPassword={confirmPassword} setConfirmPassword={setConfirmPassword} passwordError={passwordError} setPasswordError={setPasswordError} confirmPasswordError={confirmPasswordError} setConfirmPasswordError={setConfirmPasswordError} emailError={emailError} setEmailError={setEmailError} setDisableSignupBtn={setDisableSignupBtn} date={date} setDate={setDate} gender={gender} setGender={setGender} lastname={lastname} setLastname={setLastname} firstname={firstname} setFirstname={setFirstname} email={email} setEmail={setEmail} />
                        </div>
                      }  
                      
                      <div className='d-flex justify-content-between gap-10'>
                        {showdetails ?
                        <div className="w-100">
                            <Button disabled={verifyBtnDisable} onClick={handleVerifyOtp} className={`w-50 m-auto d-flex mt-4 mb-2 ${verifyBtnDisable ? "disable-btn" : "able-btn"}`} variant="contained" color="error">{t("VERIFY")}</Button>
                        </div>
                          : isChecked2 ?
                            <Button disabled={(matchPasswordError || disableSignupBtn || emailError || !firstname || !lastname || !date || passwordError || confirmPasswordError) ? true : false} onClick={handleSignup} className='w-50 m-auto d-flex mt-4 bg-theme mb-3' variant="contained" color="error">{t("SUBMIT_SIGNUP")}</Button> :
                            <Button disabled={(btnDisable || emailError || firstNameError || lastNameError || dobError) ? true : false} onClick={handleSignup} className={`w-50 m-auto d-flex bg-theme mb-3 ${btnDisable || emailError || firstNameError || lastNameError || dobError ? "disable-btn" : "able-btn"}`} variant="contained" color="error">Submit</Button>
                        }
                        </div>
                    </Modal.Body>
                  </Modal>
                </div>
                
                {/* <Button
                  onClick={() => {
                    handleGoogleLogin();
                    addEvent({
                      category: "events",
                      events: "Google Login Button",
                    });
                  }}
                  className="bg-theme w-100 font-medium mt-2 fblogin position-relative"
                  variant="contained"
                  color="error"
                >
                  <i className="ri-google-fill socila-login"></i> {t("LOGIN_WITH_GOOGLE")}
                </Button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    signup: function (data: any, history?: any) {
      dispatch(signup(data, history));
    },
    sendOtp: function (data: any, setShowDetaild: any) {
      dispatch(sendOtpForFP(data, setShowDetaild))
    },
    changePasswordOtp: function (forgetPassword: any, history: any) {
      dispatch(changePasswordOtp(forgetPassword, history))
    },
    customerSignIn: function (data: any, history: any) {
      dispatch(customerSignIn(data, history))
    },
    loginCustomerWithSocial: function (data: any, history: any) {
      dispatch(loginCustomerWithSocial(data, history))
    },
    sendOtpNew: function (data: any,setShow:any) {
      dispatch(sendOtp(data,setShow))
    },
    verifyOtpNew: function (data: any,history?:any,route?:any,setShow?:any,setShowDetaild?:any) {
      dispatch(verifyOtpNew(data,history,route,setShow,setShowDetaild))
    },
    signupNew: function (data: any,history?:any) {
      dispatch(signupNew(data,history))
    },
  }
}
export default connect(null, mapDispatchToProps)(LoginPage);


